module.exports = __webpack_public_path__ + "static/media/blogMobile.a48c3392.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/blogMobile.jpg
// module id = 730
// module chunks = 0 1 10 11